module.exports = __webpack_public_path__ + "static/media/graduation.432cbaea.png";